import * as React from 'react';
import { LineChart, lineElementClasses } from '@mui/x-charts/LineChart';
import { useData } from 'components/provider/data';
import dayjs from 'dayjs';
import { Button, ConfigProvider, Select } from 'antd';
import { useTheme } from 'components/provider/theme';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import { BarChart, legendClasses } from '@mui/x-charts';
const margin = { right: 24 };
const xLableSpacing = 16;
const xLableMode = 'left';
export default function TradeHistoryChartLine() {
    const { tradeHistoryChartData } = useData();
    const { theme } = useTheme();
    const [range, setRange] = React.useState([0, 100]);
    const [data, setData] = React.useState(tradeHistoryChartData);
    const [selectedLabel, setSelectedLabel] = React.useState<string[]>(tradeHistoryChartData[0]?.label ? [tradeHistoryChartData[0].label] : []);
    const [dataBaseOnWeek, setDataBaseOnWeek] = React.useState(
        (() => {
            // Group data points by day of week (0: Sunday, 6: Saturday)
            const weekData: { [key: number]: any[] } = {};
            tradeHistoryChartData.forEach(item => {
                item.data.forEach(point => {
                    const dayOfWeek = dayjs(point.x).day();
                    if (!weekData[dayOfWeek]) weekData[dayOfWeek] = [];
                    weekData[dayOfWeek].push(point);
                });
            });
            return weekData;
        })()
    );
    React.useEffect(() => {
        setData(tradeHistoryChartData);
        setDataBaseOnWeek((() => {
            // Group data points by day of week (0: Sunday, 6: Saturday)
            const weekData: { [key: number]: any[] } = {};
            tradeHistoryChartData.forEach(item => {
                item.data.forEach(point => {
                    const dayOfWeek = dayjs(point.x).day();
                    if (!weekData[dayOfWeek]) weekData[dayOfWeek] = [];
                    weekData[dayOfWeek].push(point);
                });
            });
            return weekData;
        })());
    }, [tradeHistoryChartData]);

    // Apply range to data
    const rangedData = data.map((item) => ({
        ...item,
        data: item.data.slice(range[0], range[1]),
    }));

    return (
        <div>
            <ConfigProvider
                theme={{
                    components: {
                        Select: {
                            optionSelectedBg: theme === 'dark' ? '#1a1a1a' : '#f0f0f0',
                            optionSelectedColor: theme === 'dark' ? '#fff' : '#000',
                            multipleItemBg: theme === 'dark' ? 'rgba(30,30,30,0.6)' : 'rgba(0,0,0,0.06)',
                            colorIcon: theme === 'dark' ? '#fff' : '#000',
                        },
                    },
                }}
            >
                <Select
                    mode="tags"
                    size={'large'}
                    allowClear
                    suffixIcon={null}
                    placeholder="Select Accounts"
                    defaultValue={selectedLabel}
                    onChange={(value: string[]) => {
                        if (selectedLabel.length < 5) {
                            setSelectedLabel(value);
                        }
                    }}
                    style={{ width: '100%' }}
                    options={
                        tradeHistoryChartData.map((item) => ({
                            value: item.label,
                            label: item.name + ' ' + item.label,
                        }))
                    }
                    maxTagCount={5}
                />
            </ConfigProvider>
            <LineChart
                height={300}
                series={rangedData
                    .filter(item => selectedLabel.length === 0 || selectedLabel.includes(item.label))
                    .map((item) => ({
                        label: item.name + ' ' + item.label,
                        data: item.data.map((point) => point.y),
                        showMark: false,
                    }))}
                sx={(themes) => ({
                    [`.${axisClasses.root}`]: {
                        [`.${axisClasses.tick}, .${axisClasses.line}`]: {
                            stroke: theme === 'dark' ? '#fff' : '#000',
                            strokeWidth: 1,
                        },
                        [`.${axisClasses.tickLabel}`]: {
                            fill: theme === 'dark' ? '#fff' : '#000',
                        },
                    },
                    [`.${legendClasses.label}`]: {
                        color: theme === 'dark' ? '#fff' : '#000',
                    },

                })}
                xAxis={[{
                    scaleType: 'point',
                    data:
                        rangedData.length > 0
                            ? rangedData[0].data.map((point) => dayjs(point.x))
                            : [],
                    tickLabelInterval: (value, index) => index % xLableSpacing === 0,
                    valueFormatter: (value, context) => {
                        if (context.location === 'tooltip') {
                            return dayjs(value).format('DD/MM/YYYY HH:mm');
                        }
                        return dayjs(value).format('DD/MM/YYYY');
                    }

                }]}
                yAxis={[{ width: 50 }]}
                margin={margin}
            />
        </div>
    );
}

